'use client'

import { usePathname } from 'next/navigation'
import Chatbot from '@/components/shared/chatbox/Chatbot'
import { walterHandler } from '@/components/shared/chatbox/utils/walterHandler'

// TODO: replaced by <NewChatWrapper />, Might need to remove this file.

// Static paths to exclude
// const INCLUDED_STATIC_PATHS = ['/crm/builder']

// const INCLUDED_PATH_PATTERNS = [
  // /^\/subaccount\/[^/]+\/landings\/[^/]+\/builder\/[^/]+$/,
  // /^\/subaccount\/[^/]+\/landings\/[^/]+\/image-assets$/,
  // /^\/crm\/builder\/[^/]+$/
// ]

export default function ChatbotWrapper() {
  const pathname = usePathname()

  const shouldInclude = () => {
    // if (INCLUDED_STATIC_PATHS.includes(pathname)) {
    //   return true
    // }

    // for (const pattern of INCLUDED_PATH_PATTERNS) {
    //   if (pattern.test(pathname)) {
    //     return true
    //   }
    // }

    return false
  }

  if (!shouldInclude()) {
    return null
  }

  return (
    <Chatbot
      flowHandler={walterHandler}
      config={{
        title: `Walter AI`,
        initialOpen: false,
        showNewMessage: true,
        showHistory: true
      }}
    />
  )
}
